import ListListings from "../components/mainpage/ListListings"
import { ListingContextProvider } from "../context/ListingsContext"
import { useState } from "react"
import {
    collection,
    query,
    where,
    getDocs,
    documentId,
    orderBy
} from "firebase/firestore"
import { db } from "../firebase"
import { useEffect, useContext } from "react"
import { AuthContext } from "../context/AuthContext"


const MyOffers = () => {
    const [listings, setListings] = useState(null)

    const { currentUser } = useContext(AuthContext)

    const getListings = async() => {
        console.log(currentUser)
        if (currentUser.activeBids.length > 0) {
            try {
                const q = query(collection(db, "listings"), where(documentId(), "in", currentUser.activeBids), orderBy("createdAt", "desc"))
                // const q = query(collection(db, "listings"), where("user", "==", "testuser5@gmail.com"))
                const querySnapshot = await getDocs(q)
                const queryRes = []
                querySnapshot.forEach((doc) => {
                    const docData = doc.data()
                    docData.listing_id = doc.id
                    queryRes.push(docData)
                })
                console.log(queryRes)
                setListings(queryRes)
            } catch(err) {
                setListings([])
                console.error(err.message)
            }
        } else {
            setListings([])
        }
    }

    useEffect(() => {
        getListings()
    }, [currentUser])


    return (
        <ListingContextProvider>
        <div className='page-container'>
            <div className="my-page">
                <div className="page-header">
                    <span className="header-text">Saved Listings</span>
                </div>
                {
                    currentUser ? <ListListings listings={listings} className={"listings-grid-full-page"}/> : <div>Loading...</div>
                }
            </div>
        </div>
        </ListingContextProvider>
    )
}

export default MyOffers